module.exports = __webpack_public_path__ + "img/portrait_photo.87326f79.jpg";